module.exports = __webpack_public_path__ + "assets/img/不良率.ae8fa173.svg";